import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta"; 
import { useEffect, useState } from "react";
import api from "../../services/api";
import Spinner from "../../components/ui/Spinner";
import {
    API_BASE_URL,
    API_URL,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
    DEFAULT_PER_PAGE,
} from "../../utilities/constants";
import { NavLink, useLocation, useNavigate } from "react-router";
import Pagination from "../../components/ui/Pagination";
import useQueryParams from "../../hooks/useQueryParams";
import { handleApiCall, jsonToQueryParams } from "../../utilities/helper";
import { useUI } from "../../context/UI";
import CustomModal from "../../components/ui/CustomModal";
import ConfirmationModal from "../../components/ui/ConfirmationModal";
import ButtonText from "../../components/ui/button/ButtonText";

const UsersPage = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(false);
    const navigate = useNavigate();
    const { updateQueryParam, queryParams } = useQueryParams();
    const pageNo = queryParams.get("pageNo") || 0;
    const pageSize = queryParams.get("pageSize") || DEFAULT_PER_PAGE;
    const sortOrder = queryParams.get("sortOrder") || "DESC";
    const location = useLocation();
    const {
        setSegmentTitle,
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();
    const [controller, setController] = useState(null);


    // useEffect(() => {
    //     getData();
    // }, [location.search]);

    const getData = async () => {
        try {
            const response = await api.get(`/api/1.0.0/agent?pageNo=${pageNo}&pageSize=${pageSize}&sortOrder=${sortOrder}`);
            if (response.data?.data?.records?.length > 0) {
                setData(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setLoading(false);
        }
    };
    
    const callListApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const query = jsonToQueryParams({
                search: queryParams.get("search") || "",
            });
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/agent?pageNo=${pageNo}&pageSize=${pageSize}&sortOrder=${sortOrder}&${query}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
            } else {
                setData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        callListApi();
        setSegmentTitle("User");
    }, [location.search]);

    const handleStatusChanges = async (id) => {
        try {
            const response = await handleApiCall(API_BASE_URL + `/api/1.0.0/agent/${id}/status/0`, {
                method: "PUT",
            });

            if (response.responseStatus === true) {
                addToastMessage({
                    status: true,
                    message:
                        "You have successfully deleted a agent, Thank You!",
                });
                callListApi();
                setNewNotification(true);
                addNotification({
                    id: Date.now(),
                    message: "You have successfully deleted a agent!",
                    status: true,
                    archive: false,
                });
            }
            else {
                addToastMessage({
                    status: false,
                    message: response?.responseDescription ||
                        `Something went wrong while deleting agent. Please try again.`,
                });
            }
        } catch (error) {
            addToastMessage({
                status: false,
                message: `Something went wrong while deleting agent. Please try again.`,
            });
        }
    };

    return (
        <>
            <PageMeta
                title={`Users - ${DEFAULT_PAGE_TITLE}`}
                description={`Users - ${DEFAULT_PAGE_DESCRIPTION}`}
            />
            <div className="flex justify-between items-center mb-4">
                <PageBreadcrumb pageTitle="Users" />
                <ButtonText
                    title='+ Add New'
                    onClick={() => { navigate('/add-user') }}
                />
            </div>
            {loading ? (
                <div className="flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (
                <div className="space-y-6">
                    <div className="relative overflow-x-auto sm:rounded-lg">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 rounded-lg">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        Name
                                    </th>

                                    <th scope="col" className="px-6 py-3">
                                        Email
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Phone Number
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.records?.map((user, index) => (
                                    <tr key={index} className="border-b dark:border-gray-600 text-sm text-gray-700 dark:text-gray-300">
                                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{user.firstName + " " + user?.lastName || 'NA'}</td>
                                        <td className="px-6 py-4">{user.email || 'NA'}</td>
                                        <td className="px-6 py-4">{user.phoneNumber || 'NA'}</td>
                                        <td className="px-6 py-4 flex gap-5">
                                            <NavLink
                                                to={`/user-details/${user?.agentId}`}
                                            >
                                                <button
                                                    type="button"
                                                    className="bg-yellow-600 text-white px-6 py-2 rounded-md hover:bg-yellow-700 transition"
                                                >
                                                    View
                                                </button>
                                            </NavLink>
                                            <NavLink to={`/edit-user/${user?.agentId}`}>
                                                <button
                                                    type="button"
                                                    className="edit-button"
                                                >
                                                    Edit
                                                </button>
                                            </NavLink>
                                            <div>
                                                <CustomModal
                                                    selector={
                                                        <span>
                                                            <button
                                                                type="button"
                                                                className="bg-red-500 text-white px-6 py-2 rounded-md hover:bg-red-700 transition"
                                                            > Delete</button>
                                                        </span>
                                                    }
                                                    content={
                                                        <ConfirmationModal
                                                            onConfirm={async () => {
                                                                await handleStatusChanges(user?.agentId);
                                                                return true;
                                                            }}
                                                            message='Are you sure you want to delete this user ?'
                                                        />
                                                    }
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            <div className='flex justify-center items-center'>
                <Pagination
                    currentPage={data?.pageNo + 1} 
                    totalElements={data?.totalRecords}
                />
            </div>
        </>
    );
};
export default UsersPage;